import { render, staticRenderFns } from "./CustomerRecordTable.vue?vue&type=template&id=ee16f38c&scoped=true"
import script from "./CustomerRecordTable.vue?vue&type=script&lang=js"
export * from "./CustomerRecordTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerRecordTable.vue?vue&type=style&index=0&id=ee16f38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee16f38c",
  null
  
)

export default component.exports